
import { Injectable, OnInit } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable, of } from "rxjs";
import {chiefsOrderLevel } from '../models/comodel/chiefsOrderLevel.model';
import { AuthService } from "./auth.service";
import { levelContext, ChiefsOrderInstance} from "../models/comodel/chiefsorderdetailsmodel.model";
import { coReviewViewModel } from "../models/comodel/coreviewviewmodel.model";
import { tap } from "rxjs/operators";
import { IUploadFile } from "../common/services/document-management.service";
import { Signature } from "../common/models/signature.model";
import { ChiefsOrderSearchSpec } from "../models/comodel/chiefs-order-search-spec.model";
import { GenerateReportModel } from '../reports/model/reports.model';
import { deepClone } from "../builder/models/editor.model";
 

@Injectable()
export class ChiefsOrderService implements OnInit {

    private reviewModel: coReviewViewModel | null;
    private initiatedModel: levelContext | null;
    
    constructor(public http: HttpClient,public _authService: AuthService)
    {
       
    }
    ngOnInit() { }

    generateChiefsOrderDocument(model: GenerateReportModel): Observable<any> {
        return this.http.post("/api/chiefs-orders/generate-document", model, { responseType: 'blob' as 'blob' });
    }

    getChiefsOrderContext(coInstanceId: string): Observable<levelContext> {
        return this.http.get(`/api/chiefs-orders/get-chiefs-order-context/${coInstanceId}`);
    }

    saveChiefsOrderContext(coInfo: levelContext): Observable<any> {
        return this.http.post("/api/chiefs-orders/save-chiefs-order-context", coInfo);
    }

    getCoLevelsByCategory(code: string): Observable<chiefsOrderLevel[]> {
        return this.http.get<chiefsOrderLevel[]>(`/api/chiefs-orders/loadCoConfig/${code}`);
    }

    saveCoLevelRecord(coLevel: chiefsOrderLevel): Observable<any> {
        coLevel.lastUpdatedBy = this._authService.User.displayName;
        return this.http.post("/api/chiefs-orders/savecolevel", coLevel);
    }

    deleteCoLevelRecord(id: string, categoryCode:string): Observable<any> {         
        return this.http.post(`/api/chiefs-orders/deletecolevel/${categoryCode}/${id}`, {});
    }
    
    saveMergeFields(coInfo: levelContext): Observable<any> {       
        return this.http.post("/api/chiefs-orders/saveMergefields",coInfo );
    }

    getlettercontents(coinstanceId: string): Observable<levelContext> {
        var coinstanceid = coinstanceId;   
        if (this.initiatedModel != null && this.initiatedModel.id == coinstanceId) {
            return of(this.initiatedModel);
        }
        return this.http.get(`/api/chiefs-orders/getlettercontents/${coinstanceid}`);
    }  

    saveletter(coInfo: levelContext): Observable<any> {         
        return this.http.post("/api/chiefs-orders/saveletter", coInfo)
            .pipe(tap(data => this.initiatedModel = coInfo));
    }
     
    submitco(coInstanceId: string): Observable<any> {            
        return this.http.post(`/api/chiefs-orders/savecorequest/${coInstanceId}`, {} );
    }

    getChiefsOrderInstances(searchSpec: ChiefsOrderSearchSpec): Observable<Array<ChiefsOrderInstance>> {
        const url = `/api/chiefs-orders/search`;
        let chiefsOrderInstances = this.http.post<Array<ChiefsOrderInstance>>(url, searchSpec);
        return chiefsOrderInstances;
    }

    getchiefsorderinreview(coInstanceId: string): Observable<coReviewViewModel> {
        if (this.reviewModel && this.reviewModel.instanceId == coInstanceId) {
            return of(this.reviewModel);
        }
        return this.http.get(`/api/chiefs-orders/getchiefsorderinreview/${coInstanceId}`).pipe(
            tap<coReviewViewModel>(data => this.reviewModel = data));
    }
    returnco(model: coReviewViewModel): Observable<any> {        
        return this.http.post("/api/chiefs-orders/savereviewedco", model)
            .pipe(tap(data => this.reviewModel = null));
    }
    rejectco(model: coReviewViewModel): Observable<any> {         
        return this.http.post("/api/chiefs-orders/savereviewedco", model)
            .pipe(tap(data => this.reviewModel = null));
    }
    cancelco(model: coReviewViewModel): Observable<any> {
        return this.http.post("/api/chiefs-orders/savereviewedco", model)
            .pipe(tap(data => this.reviewModel = null));
    }
    approveco(model: coReviewViewModel): Observable<any> {   
        if (model && model.currentLevel && model.currentLevel.mode && model.currentLevel.mode.toLowerCase() === 'chief') {
            return this.http.post("/api/chiefs-orders/savereviewedco", model)
                .pipe(tap(data => this.reviewModel = model));
        }
        else {
            return this.http.post("/api/chiefs-orders/savereviewedco", model)
                .pipe(tap(data => this.reviewModel = null));
        }
    }
    legalapproveco(model: coReviewViewModel): Observable<any> {         
        return this.http.post("/api/chiefs-orders/savereviewedco", model)
            .pipe(tap(data => this.reviewModel = null));
    }
    saveletterfromreview(model: coReviewViewModel): Observable<any> {  
        return this.http.post("/api/chiefs-orders/savereviewletter", model)
            .pipe(tap(data => {
                if (this.reviewModel && this.reviewModel.timeline) {
                    let timeline = deepClone(this.reviewModel.timeline);
                    data.timeline = timeline;
                }
                this.reviewModel = data;
            }))
    }
    savereviewnote(model: coReviewViewModel): Observable<any> {
        return this.http.post("/api/chiefs-orders/savereviewnote", model)
            .pipe(tap(data => {
                if (this.reviewModel && this.reviewModel.instanceId == data.instanceId) {
                    this.reviewModel.notes = data.notes;
                }
            }))
    }
    saveFilesToContext(file: IUploadFile, coInstanceId: string, isSupplemental: boolean = false): Observable<any> {
        return this.http.post<IUploadFile>(`/api/chiefs-orders/saveFile/${coInstanceId}/${isSupplemental}`, file)
            .pipe(tap(data => this.reviewModel = null))

    }
    getFilesFromContext(coInstanceId: string): Observable<IUploadFile[]> {        
            return this.http.get<IUploadFile[]>(`/api/chiefs-orders/getfilesfromcontext/${coInstanceId}`).pipe(
                tap(data => {
                    if (this.reviewModel) {
                        this.reviewModel.files = data;
                    }
                }
            ));
    }

    deleteFilesFromContext(file: IUploadFile, coInstanceId: string): Observable<any> {
        return this.http.post<IUploadFile>(`/api/chiefs-orders/deleteFile/${coInstanceId}`, file).
        pipe(tap(data => this.reviewModel = null))
    }

    getCurrReqSignersList(): Observable<string[]> {
        var reportTemplateId = this.reviewModel.templateId;
        return this.http.get<string[]>(`api/reports/getsignerslist/${reportTemplateId}`);
    } 
    saveChiefsSignature(signedObj: Signature, ): Observable<any> {
        return this.http.post("/api/chiefs-orders/savereviewsignature", signedObj); 
    }

    saveChiefsOrderInstance(instanceToSave: ChiefsOrderInstance): Observable<any> {
        return this.http.post("/api/chiefs-orders/saveinstance", instanceToSave);
    }
}

